/** Statuses that say nothing about whether someone turned up for a working day. */
const NOT_A_MARKED_DAY = new Set(["holiday", "weekly_off", "not_marked"]);

/**
 * "94% of marked days" for one status in the dashboard's attendance mix.
 *
 * The mix counts person-days across the month, so it can only be compared with
 * other person-days: dividing by headcount is what produced figures like "347%
 * of workforce". Undefined when nothing is marked yet, or the mix is withheld
 * from this role, so the card shows no percentage rather than a misleading 0%.
 */
export function attendanceShareHint(
  mix: Record<string, number> | undefined,
  status: string,
  decimals = 0,
): string | undefined {
  const entries = Object.entries(mix ?? {});
  const markedDays = entries.reduce((sum, [key, count]) => (NOT_A_MARKED_DAY.has(key) ? sum : sum + count), 0);
  if (markedDays === 0) return undefined;
  const share = ((mix?.[status] ?? 0) / markedDays) * 100;
  return `${share.toFixed(decimals)}% of marked days`;
}
